import React from "react";

const p = { color: "#ccc", marginBottom: "1.25rem", lineHeight: 1.65 };

export default function AboutPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        boxSizing: "border-box",
        background: "#111111",
        color: "white",
        padding: "clamp(2rem, 5vw, 3.5rem) clamp(1.25rem, 4vw, 2.5rem)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "680px",
          margin: "0 auto",
        }}
      >
        <h1
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "1.35rem",
            marginTop: 0,
            letterSpacing: "-0.02em",
          }}
        >
          Why PaceWerks
        </h1>
        <p style={p}>
          Running is one of the most natural things we do as humans. Long before
          watches, apps, or finish lines, running was how we survived. Today we
          run for sport, for health, for clarity, or simply for the challenge.
        </p>
        <p style={p}>
          As the sport has evolved, so has the technology around it. Heart rate
          zones, AI pacing tools, monthly subscriptions, social comparisons, and
          an overwhelming number of metrics. But training for a race doesn&apos;t
          need to be that complicated.
        </p>
        <p style={p}>
          At PaceWerks, we sit comfortably in the middle. Smarter than winging it,
          simpler than most. No subscriptions, no bloat. Just custom-built training
          plans based on real logic.
        </p>
        <p style={{ ...p, marginBottom: "2.75rem" }}>
          <strong>Build your plan, trust the process, and go run.</strong>
          <br />
          <br />
          That&apos;s it. We hope your plan carries you to your next finish line.
        </p>

        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginTop: "3rem",
            marginBottom: "1.35rem",
            letterSpacing: "-0.02em",
          }}
        >
          About Me
        </h2>
        <p style={p}>
          I&apos;ve been running and doing triathlons for years and in that time
          I&apos;ve tried pretty much everything. Hired a coach (super helpful,
          also expensive), printed random plans from the internet, reused old race
          schedules. You name it.
        </p>
        <p style={p}>
          That&apos;s what got me thinking there had to be a better way. So I
          started building PaceWerks. Zero coding experience, a lot of late
          nights, and one simple goal: make something useful for everyday runners
          who want a smart, flexible plan without overcomplicating it.
        </p>
        <p style={{ ...p, marginBottom: "2.5rem" }}>
          Hope it helps you train with more confidence and less chaos.
        </p>

        <div
          style={{
            borderTop: "1px solid rgba(255, 255, 255, 0.12)",
            paddingTop: "2rem",
            marginTop: "0.5rem",
          }}
        >
          <p
            style={{
              color: "#888",
              fontSize: "1rem",
              fontWeight: 400,
              margin: 0,
            }}
          >
            David - Founder
          </p>
        </div>
      </div>
    </div>
  );
}
